'use strict'

const get_ = require('lodash/get')
const isObject_ = require('lodash/isObject')
const maybe = require('folktale/maybe')

const {
  isFieldFromReferencedCollection,
  getReferenceFieldName,
  getFieldFromReferencedCollectionName
} = require('dbsm-common/src/reference-fields/fieldPath')

const getFieldValue = fieldName => record => get_(record, fieldName)

const getReference = fieldPath => record =>
  maybe.fromNullable(get_(record, getReferenceFieldName(fieldPath)))

const getFieldFromReference = fieldPath => reference =>
  maybe
    .fromNullable(reference)
    .chain(
      reference =>
        isObject_(reference) ? maybe.Just(reference) : maybe.Nothing()
    )
    .map(referencedRecord =>
      getFieldValue(getFieldFromReferencedCollectionName(fieldPath))(
        referencedRecord
      )
    )
    .getOrElse(undefined)

module.exports = (record, fieldPath) =>
  isFieldFromReferencedCollection(fieldPath)
    ? getReference(fieldPath)(record)
        .map(getFieldFromReference(fieldPath))
        .getOrElse(undefined)
    : getFieldValue(fieldPath)(record)



// WEBPACK FOOTER //
// ./helpers/getFieldValue.js